<template>
  <div id="evolution" class="">
    <div class="col-card mh maximizable">
      <button class="d-block btn-enlarge maximize-btn" @click.stop="maximize">
        <i class="fas fa-expand"></i>
      </button>
      <button class="btn-minimize minimize-btn" @click.stop="minimize">
        <i class="fas fa-compress"></i>
      </button>
      <div class="row chart-nagiviation align-items-baseline">
        <h2 class="mr-3 col-auto">{{ $t('message.evolution') }}</h2>
        <div class="dp-start flat-date-pickr">
          <label class="mr-3" for="start">{{ $t('message.from') }}</label>
          <input
            name="start"
            id="start"
            v-model="startDate" type="date"
            :max="today"
            class="w-auto d-inline mb-0 styled-input c_date_picker form-control">
        </div>
        <div class="ml-3 dp-end flat-date-pickr">
          <label class="mr-3" for="end">{{ $t('message.to') }}</label>
          <input
            name="end"
            id="end"
            v-model="endDate"
            type="date"
            :max="today"
            class="w-auto d-inline mb-0 styled-input c_date_picker form-control">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">

<span v-if="vipHistory.length">
    <evolution-chart :name="'user-evolution'"
                     :dateLabels="labels"
                     v-if="vipHistory.length && labels.length"
                     :setLabels="[$t('message.score'),]"
                     :start="startDate"
                     :end="endDate"
                     :entity="user"
                     :type="'user'"
                     :vitaminScores="vitaminScores"
                     :chartData="[vipHistory,]">
          </evolution-chart>
</span>
          <span v-else>
            <p>{{$t('message.no_results_yet')}}</p>
          </span>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import EvolutionChart from '../Charts/EvolutionChart'
  import Chart from 'chart.js'
  import moment from 'moment'
  import store from "../../store/store";

  export default {
    props: {
      vitaminScores: {
        type: Object,
        default() {
          return {}
        }
      },
      vitamins: {
        type: Array,
        default() {
          return []
        }
      }
    },
    components: {
      EvolutionChart
    },
    watch: {
      dates() {
        this.getSubmissions()
      }
    },
    methods: {
      async getSubmissions() {
        this.vipHistory = [];
        const submissions = await this.axios.get(`/submissions?status_ne=draft&_sort=finalized:ASC&finalized_gte=${this.startDate}&finalized_lte=${moment(this.endDate).add(1, 'day').format('YYYY-MM-DD')}`);

        submissions.data.forEach(submission => {
          let submissionDate = moment(submission.finalized);
          this.dates.forEach(date => {
            let day = moment(date);
            let val = null;

            if (day.isSame(submissionDate, 'day')) {
              val = submission.vipscore
            }
            this.vipHistory.push(val)
          })
        });
      },
    },
    computed: {
      randomSubmissions() {
        let subs = [];
        if (this.labels) {

          let length = this.labels.length;
          this.labels.forEach((date, ind) => {
            let val = null;
            if ((ind % 7) === 0) {
              val = Math.floor(Math.random() * 7) + 1
            }
            subs.push(val)
          });
        }
        return subs
      },
      dates() {
        return this.getDatesBetween(this.startDate, this.endDate, 'YYYY-MM-DD')
      },
      labels() {
        return this.getDatesBetween(this.startDate, this.endDate)
      }
    },
    data() {
      return {
        user: store.getters.getUser,
        vipHistory: [],
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        chart: {
          type: 'line',
          data: {
            labels: [],
            datasets: []
          },
          options: {
            legend: {
              labels: {
                usePointStyle: true,
                fontStyle: 'Light',
                fontFamily: 'Roboto'
              },
              align: 'end',
              position: 'bottom'
            },
            scales: {
              xAxes: [{
                gridLines: {
                  color: '#5f6165',
                  drawOnChartArea: false,
                  borderDashOffset: 5
                },
              }],
              yAxes: [{
                gridLines: {
                  color: '#5f6165',
                  drawOnChartArea: false,
                  display: false
                },
                ticks: {
                  stepSize: 1,
                  min: 0,
                  max: 5,
                  beginAtZero: true
                }
              }]
            }
          }
        }
      }
    },
    created() {
      this.getSubmissions();
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Evolution.vue